import React from 'react';
import Box from '@mui/material/Box';

export default function HalfSizeBanner({ children, height = '460px' }) {
    return (
        <Box sx={{height: height }}>
            {children}
        </Box>
    )
}